import { EEntityTypeOld } from '../../../shared/types/results';
import { COUNTS_SET_COUNTS, COUNTS_DECREMENT } from '../../constants/actionTypes';
import { IFavoriteCountsSchema } from '../../repositories/favorites/entities/favorite_counts/FavoriteCountsSchema';
import { EEntityType } from '../../types/filters';
import { TReduxActions } from '../../types/redux';

function convertToFavoriteEntityType(entityType: EEntityType): EEntityTypeOld {
  const map = {
    [EEntityType.Commercial]: EEntityTypeOld.OfferCommercial,
    [EEntityType.Residential]: EEntityTypeOld.OfferResidental,
    [EEntityType.Suburban]: EEntityTypeOld.OfferSuburban,
    [EEntityType.Newbuilding]: EEntityTypeOld.Newbuilding,
  };

  return map[entityType];
}

const defaultState = {
  rent: {
    offerCommercial: 0,
    offerResidental: 0,
    offerSuburban: 0,
  },
  sale: {
    offerCommercial: 0,
    offerResidental: 0,
    offerSuburban: 0,
  },
  total: 0,
};

export function countsReducer(state: IFavoriteCountsSchema | undefined = defaultState, action: TReduxActions) {
  switch (action.type) {
    case COUNTS_SET_COUNTS:
      return {
        ...state,
        ...action.data,
      };

    case COUNTS_DECREMENT: {
      const entity = convertToFavoriteEntityType(action.entityType as EEntityType);
      const entityCount = state[action.dealType][entity];

      return {
        ...state,
        total: state.total ? state.total - 1 : state.total,
        [action.dealType]: {
          ...state[action.dealType],
          [entity]: entityCount ? entityCount - 1 : entityCount,
        },
      };
    }

    default:
      return state;
  }
}
